import GlobalMethods from "@/lib/GlobalMethods"
import moment from "moment";

const state = {
  contexts: {},
  organization: null,
  organizationsGroupId: null,
  organizationsGroupGuid: null,
  organizationGuid: null,
  budget: null,
  year: null,
  field: null,
  startDateOfGrainBalance: null,
  endDateOfGrainBalance: null,
  echelonType: null,
  childOrganizationId: null,
}

const getters = {
  getContexts: (state) => {
    return state.contexts
  },
  getContext: (state) => (name) => {
    if (name === "startDateOfGrainBalance") {
      return moment(state[name], "YYYY-MM-DD")
    }
    return state[name]
  },
  getOrganization: (state) => {
    return state.organization
  },
  getOrganizationsGroupId: (state) => {
    return state.organizationsGroupId
  },
  getOrganizationsGuid: (state) => {
    return state.organizationGuid
  },
  getOrganizationsGroupGuid: (state) => {
    return state.organizationsGroupGuid
  },
  getBudget: (state) => {
    return state.budget
  },
  getYear: (state) => {
    return state.year
  },
  getField: (state) => {
    return state.field
  },
  getEchelonType: (state) => {
    return state.echelonType
  },
  getChildOrganizationId: (state) => {
    return state.childOrganizationId
  },
  getCurrentYearGrainBalance: (state) => (date) => {
    let year = date ? moment(date, "YYYY-MM-DDTHH:mm:ss").year() : state.year
    date = date ? moment(date, "YYYY-MM-DDTHH:mm:ss") : moment()
    if (moment(date).month() < 6) {
      return year + 1
    }
    else {
      return year
    }
  },
  getCurrentYearGrainBalanceRequest: (state) => (date) => {
    let year = date ? moment(date, "YYYY-MM-DDTHH:mm:ss").year() : state.year
    date = date ? moment(date, "YYYY-MM-DDTHH:mm:ss") : moment()
    if (moment(date).month() < 6) {
      return year - 1
    }
    else {
      return year
    }
  },
}

const mutations = {
  initContexts: (state) => {
    let contexts = JSON.parse(localStorage.getItem("contexts")) || {}
    state.contexts = contexts
    state.organization = contexts.organization
    state.organizationsGroupId = contexts.organizationsGroupId
    state.budget = contexts.budget
    state.year = contexts.year
    state.field = contexts.field
    state.echelonType = contexts.echelonType
  },
  setContext: (state, {name, val}) => {
    if (name === "startDateOfGrainBalance") {
      val = moment(val).format("YYYY-MM-DD")
    }
    state[name] = val
    state.contexts[name] = val
  },
  saveContexts: (state) => {
    localStorage.setItem("contexts", JSON.stringify(state.contexts))


    let contexts = JSON.parse(localStorage.getItem("contexts")) || {}

  },
  removeContexts: () => {
    localStorage.removeItem("contexts")
  },
  setOrganizationGuid: (state) => {
    state.organizationGuid = GlobalMethods.getOrganizationGuid()
    state.contexts.organizationGuid = state.organizationGuid
  },
  setOrganizationsGroupGuid: (state) => {
    state.organizationsGroupGuid = GlobalMethods.getOrganizationGroupGuid(state.organization)
    state.contexts.organizationsGroupGuid = state.organizationsGroupGuid
  },
}

const actions = {
  actionInitContexts: ({commit, state, dispatch}) => {
    commit("initContexts")
  },
  actionSetContext: ({commit}, {name, val, reload, organizationTypeDiffer = false}) => {
    commit("setContext", {name, val})
    commit("saveContexts")
    if (reload) {
      if (organizationTypeDiffer) {
        window.location = "/"
      } else {
        window.location.reload(true)
      }
    }
  },
  actionRemoveContexts: ({commit}) => {
    commit("removeContexts")
  },
  actionSetOrganization: ({dispatch, getters}, {val, reload}) => {
    let organizationTypeDiffer = false
    if (getters.getOrganization !== val) {
      let organizationType = GlobalMethods.getOrganizationType(getters.getOrganization)
      let newOrganizationType = GlobalMethods.getOrganizationType(val)
      organizationTypeDiffer = organizationType !== newOrganizationType

      if (localStorage.getItem("pickedWarehouseIds")) {
        localStorage.removeItem("pickedWarehouseIds")
      }
    }


    dispatch("actionSetContext", {name: "organization", val, reload, organizationTypeDiffer})
  },
  actionSetOrganizationsGroupId: ({dispatch}, {val, reload}) => {
    dispatch("actionSetContext", {name: "organizationsGroupId", val, reload})
  },
  actionSetOrganizationsGroupGuid: ({commit}) => {
    commit("setOrganizationsGroupGuid")
  },
  actionSetOrganizationGuid: ({commit}) => {
    commit("setOrganizationGuid")
  },
  actionSetBudget: ({dispatch}, {val, reload}) => {
    dispatch("actionSetContext", {name: "budget", val, reload})
  },
  actionSetYear: ({dispatch}, {val, reload}) => {
    dispatch("actionSetContext", {name: "year", val, reload})
  },
  actionSetField: ({dispatch}, {val, reload}) => {
    dispatch("actionSetContext", {name: "field", val, reload})
  },
  actionSetEchelonType: ({dispatch}, {val, reload}) => {
    dispatch("actionSetContext", {name: "echelonType", val, reload})
  },
  actionSetChildOrganizationId: ({dispatch}, {val, reload}) => {
    dispatch("actionSetContext", {name: "childOrganizationId", val, reload})
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
